module.exports = __webpack_public_path__ + "static/img/img13.85cde48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c37/img13.png
// module id = 7+eu
// module chunks = 0